var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3",
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-danger",
            attrs: { type: "button", disabled: _vm.loading },
            on: { click: _vm.printPdf },
          },
          [
            _c("i", { staticClass: "fa fa-file-pdf-o me-1" }),
            _vm._v("\n            Print PDF\n        "),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card border-0 shadow-sm mb-3" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row g-3" }, [
          _c("div", { staticClass: "col-12 col-md-6 col-xl-3" }, [
            _c(
              "label",
              { staticClass: "form-label small fw-semibold text-muted" },
              [
                _vm._v(
                  "\n                        No. Registrasi\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter.Regno,
                  expression: "filter.Regno",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "No. Registrasi",
                disabled: _vm.loading,
              },
              domProps: { value: _vm.filter.Regno },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.applyFilter.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filter, "Regno", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-6 col-xl-3" }, [
            _c(
              "label",
              { staticClass: "form-label small fw-semibold text-muted" },
              [
                _vm._v(
                  "\n                        No. Rekam Medis\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter.Medrec,
                  expression: "filter.Medrec",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "No. RM",
                disabled: _vm.loading,
              },
              domProps: { value: _vm.filter.Medrec },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.applyFilter.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filter, "Medrec", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-6 col-xl-3" }, [
            _c(
              "label",
              { staticClass: "form-label small fw-semibold text-muted" },
              [
                _vm._v(
                  "\n                        Nama Pasien\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter.Firstname,
                  expression: "filter.Firstname",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "Nama pasien",
                disabled: _vm.loading,
              },
              domProps: { value: _vm.filter.Firstname },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.applyFilter.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filter, "Firstname", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-6 col-xl-3" }, [
            _c(
              "label",
              { staticClass: "form-label small fw-semibold text-muted" },
              [
                _vm._v(
                  "\n                        Tanggal Dari\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter.date1,
                  expression: "filter.date1",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "date", disabled: _vm.loading },
              domProps: { value: _vm.filter.date1 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filter, "date1", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-6 col-xl-3" }, [
            _c(
              "label",
              { staticClass: "form-label small fw-semibold text-muted" },
              [
                _vm._v(
                  "\n                        Tanggal Sampai\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter.date2,
                  expression: "filter.date2",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "date", disabled: _vm.loading },
              domProps: { value: _vm.filter.date2 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filter, "date2", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex gap-2 mt-3" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button", disabled: _vm.loading },
              on: { click: _vm.applyFilter },
            },
            [
              _vm.loading
                ? _c("span", {
                    staticClass: "spinner-border spinner-border-sm me-1",
                  })
                : _c("i", { staticClass: "fa fa-search me-1" }),
              _vm._v("\n                    Cari\n                "),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-outline-secondary",
              attrs: { type: "button", disabled: _vm.loading },
              on: { click: _vm.resetFilter },
            },
            [
              _c("i", { staticClass: "fa fa-refresh me-1" }),
              _vm._v("\n                    Reset\n                "),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card border-0 shadow-sm" }, [
      _c("div", { staticClass: "card-header bg-white" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-wrap align-items-center justify-content-between gap-2",
          },
          [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center gap-2" }, [
              _c("span", { staticClass: "small text-muted" }, [
                _vm._v("Tampilkan"),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.perPage,
                      expression: "perPage",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "form-select form-select-sm per-page",
                  attrs: { disabled: _vm.loading },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return _vm._n(val)
                          })
                        _vm.perPage = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      function ($event) {
                        return _vm.loadData(1)
                      },
                    ],
                  },
                },
                [
                  _c("option", { domProps: { value: 10 } }, [_vm._v("10")]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: 25 } }, [_vm._v("25")]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: 50 } }, [_vm._v("50")]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: 100 } }, [_vm._v("100")]),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "small text-muted" }, [_vm._v("data")]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body p-0 position-relative" }, [
        _vm.loading
          ? _c("div", { staticClass: "loading-overlay" }, [_vm._m(3)])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "table-responsive" }, [
          _c(
            "table",
            {
              staticClass: "table table-bordered table-hover align-middle mb-0",
            },
            [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.rows, function (item, index) {
                    return _c(
                      "tr",
                      {
                        key: item.regno + "-" + index,
                        class: {
                          "table-danger": !item.status,
                        },
                      },
                      [
                        _c("td", [_vm._v(_vm._s(_vm.rowNumber(index)))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.show(item.regno)))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.show(item.medrec)))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.show(item.firstname)))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatDate(item.regdate))),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatTime(item.regtime))),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatDate(item.tanggalmasuk))),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatTime(item.jammasuk))),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.show(item.status)))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.show(item.nmpoli)))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.show(item.nmdoc)))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.show(item.nmtuju)))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.show(item.nmcbayar)))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.show(item.validuser)))]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.openEdit(item)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa fa-edit" })]
                          ),
                        ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  !_vm.loading && _vm.rows.length === 0
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center text-muted py-4",
                            attrs: { colspan: "15" },
                          },
                          [
                            _vm._v(
                              "\n                                Data tidak ditemukan.\n                            "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-footer bg-white" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-between align-items-center flex-wrap gap-2",
          },
          [
            _c("small", { staticClass: "text-muted" }, [
              _vm._v(
                "\n                    Menampilkan " +
                  _vm._s(_vm.pagination.from || 0) +
                  " -\n                    " +
                  _vm._s(_vm.pagination.to || 0) +
                  " dari\n                    " +
                  _vm._s(_vm.pagination.total || 0) +
                  " data\n                "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn-group" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-outline-secondary",
                  attrs: {
                    disabled: _vm.pagination.current_page <= 1 || _vm.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.loadData(_vm.pagination.current_page - 1)
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-chevron-left" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-light",
                  attrs: { disabled: "" },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.pagination.current_page) +
                      "\n                        /\n                        " +
                      _vm._s(_vm.pagination.last_page) +
                      "\n                    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-outline-secondary",
                  attrs: {
                    disabled:
                      _vm.pagination.current_page >= _vm.pagination.last_page ||
                      _vm.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.loadData(_vm.pagination.current_page + 1)
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-chevron-right" })]
              ),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.modal
      ? _c(
          "div",
          {
            staticClass: "custom-modal",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.closeModal.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "custom-modal-dialog" }, [
              _c("div", { staticClass: "card border-0 shadow-lg" }, [
                _c(
                  "div",
                  { staticClass: "card-header bg-success text-white" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center",
                      },
                      [
                        _c("strong", [_vm._v("File Status Masuk")]),
                        _vm._v(" "),
                        _c("button", {
                          staticClass: "btn-close btn-close-white",
                          attrs: { type: "button" },
                          on: { click: _vm.closeModal },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "row g-3" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v("No. Registrasi"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.noRegno,
                            expression: "form.noRegno",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { readonly: "" },
                        domProps: { value: _vm.form.noRegno },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form, "noRegno", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v("No. RM"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.noMedrec,
                            expression: "form.noMedrec",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { readonly: "" },
                        domProps: { value: _vm.form.noMedrec },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form, "noMedrec", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v("Nama Pasien"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.nama_pasien,
                            expression: "form.nama_pasien",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { readonly: "" },
                        domProps: { value: _vm.form.nama_pasien },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form,
                              "nama_pasien",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v("Tanggal"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.no_tanggal,
                            expression: "form.no_tanggal",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "date", readonly: "" },
                        domProps: { value: _vm.form.no_tanggal },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form,
                              "no_tanggal",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v("Jam"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.no_jam,
                            expression: "form.no_jam",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { readonly: "" },
                        domProps: { value: _vm.form.no_jam },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form, "no_jam", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("label", { staticClass: "form-label fw-semibold" }, [
                        _vm._v(
                          "\n                                Status\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check mb-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.Status,
                              expression: "form.Status",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            id: "masuk-status-1",
                            type: "radio",
                            value: "1",
                          },
                          domProps: { checked: _vm._q(_vm.form.Status, "1") },
                          on: {
                            change: function ($event) {
                              return _vm.$set(_vm.form, "Status", "1")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "masuk-status-1" },
                          },
                          [
                            _vm._v(
                              "\n                                    Status Kembali\n                                "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.Status,
                              expression: "form.Status",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            id: "masuk-status-2",
                            type: "radio",
                            value: "2",
                          },
                          domProps: { checked: _vm._q(_vm.form.Status, "2") },
                          on: {
                            change: function ($event) {
                              return _vm.$set(_vm.form, "Status", "2")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "masuk-status-2" },
                          },
                          [
                            _vm._v(
                              "\n                                    Mutasi Rawat Inap\n                                "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(
                          "\n                                Nama Peminjam / Penjamin\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.NmPenjamin,
                            expression: "form.NmPenjamin",
                          },
                        ],
                        staticClass: "form-control",
                        domProps: { value: _vm.form.NmPenjamin },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form,
                              "NmPenjamin",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v("Bagian"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.noBagian,
                            expression: "form.noBagian",
                          },
                        ],
                        staticClass: "form-control",
                        domProps: { value: _vm.form.noBagian },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form, "noBagian", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v("Keterangan"),
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.keterangan,
                            expression: "form.keterangan",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { rows: "3" },
                        domProps: { value: _vm.form.keterangan },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form,
                              "keterangan",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer bg-white text-end" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary me-2",
                      attrs: { disabled: _vm.saving },
                      on: { click: _vm.closeModal },
                    },
                    [
                      _vm._v(
                        "\n                        Tutup\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { disabled: _vm.saving },
                      on: { click: _vm.save },
                    },
                    [
                      _vm.saving
                        ? _c("span", {
                            staticClass:
                              "spinner-border spinner-border-sm me-1",
                          })
                        : _c("i", { staticClass: "fa fa-save me-1" }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.saving ? "Menyimpan..." : "Simpan") +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h3", { staticClass: "mb-1" }, [_vm._v("File Status Masuk")]),
      _vm._v(" "),
      _c("div", { staticClass: "text-muted" }, [
        _vm._v(
          "\n                Monitoring pengembalian berkas rekam medis.\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-white fw-semibold" }, [
      _c("i", { staticClass: "fa fa-filter text-primary me-1" }),
      _vm._v("\n            Pencarian Data\n        "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "fw-semibold" }, [
      _c("i", { staticClass: "fa fa-folder-open text-success me-1" }),
      _vm._v(
        "\n                    Daftar File Status Masuk\n                "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("div", { staticClass: "spinner-border text-primary" }),
      _vm._v(" "),
      _c("div", { staticClass: "mt-2 text-muted" }, [_vm._v("Memuat data...")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", [_vm._v("No")]),
        _vm._v(" "),
        _c("th", [_vm._v("No.Reg")]),
        _vm._v(" "),
        _c("th", [_vm._v("RM")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nama Pasien")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tgl Reg")]),
        _vm._v(" "),
        _c("th", [_vm._v("Jam Reg")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tgl Masuk")]),
        _vm._v(" "),
        _c("th", [_vm._v("Jam Masuk")]),
        _vm._v(" "),
        _c("th", [_vm._v("Keterangan")]),
        _vm._v(" "),
        _c("th", [_vm._v("Poli")]),
        _vm._v(" "),
        _c("th", [_vm._v("Dokter")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tujuan")]),
        _vm._v(" "),
        _c("th", [_vm._v("Bayar")]),
        _vm._v(" "),
        _c("th", [_vm._v("User")]),
        _vm._v(" "),
        _c("th", [_vm._v("Action")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }